import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface GlobalState {
  isConnectedWithInternet: boolean
  isIpadView: boolean
}

const initialState: GlobalState = {
  isConnectedWithInternet: true,
  isIpadView: false,
}

const globalStateSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setIsIpadView: (state, action: PayloadAction<boolean>) => {
      state.isIpadView = action.payload
    },
    connected: (state) => {
      state.isConnectedWithInternet = true
    },
    disconnected: (state) => {
      state.isConnectedWithInternet = false
    },
    reset: () => initialState,
  },
})

export const globalStateActions = globalStateSlice.actions
export const globalStateReducer = globalStateSlice.reducer
export default globalStateActions
